import { tenantHttp, type HttpClient, type QueryParams } from './core/http-client';
import type { BulkInvitationResult, Invitation, InvitationTemplate } from './models';

export class InvitationsService {
  constructor(private readonly http: HttpClient) {}

  list = (query: QueryParams) => this.http.getPage<Invitation>('/business/invitations', { query });

  create = (b: unknown, idempotencyKey: string) =>
    this.http.post<Invitation>('/business/invitations', b, {
      headers: { 'idempotency-key': idempotencyKey },
    });

  bulk = (invitations: unknown[]) =>
    this.http.post<BulkInvitationResult>(
      '/business/invitations/bulk',
      { invitations },
      { timeoutMs: 120_000 },
    );

  cancel = (id: string) => this.http.post(`/business/invitations/${id}/cancel`);

  resend = (id: string) => this.http.post(`/business/invitations/${id}/resend`);

  templates = () => this.http.get<InvitationTemplate[]>('/business/invitation-templates');

  saveTemplate = (id: string | null, b: Omit<InvitationTemplate, 'id'>) =>
    id
      ? this.http.patch(`/business/invitation-templates/${id}`, b)
      : this.http.post('/business/invitation-templates', b);

  archiveTemplate = (id: string) => this.http.delete(`/business/invitation-templates/${id}`);
}

export const invitationsService = new InvitationsService(tenantHttp);
